'use client';
import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useMetrica } from 'next-yandex-metrica';
import { safeAuthReturn } from '@/shared/lib/auth-return';
import {
	freeAuthAttribution,
	freeEvent,
} from '@/features/free-interview/navigation';

export function FreeAuthAnalytics() {
	const path = usePathname();
	const params = useSearchParams();
	const { reachGoal } = useMetrica();
	const seen = useRef('');
	const target = safeAuthReturn(params.get('redirect'));
	useEffect(() => {
		if (!target) return;
		const attribution = freeAuthAttribution(target);
		if (!attribution) return;
		const key = path + ':' + target;
		if (seen.current === key) return;
		seen.current = key;
		const context = { ...attribution, step: path.replaceAll('/', '_') };
		freeEvent(reachGoal, 'auth_view', context);
		try {
			sessionStorage.setItem(
				'free_interview_auth_return',
				JSON.stringify(context),
			);
		} catch {
			/* Optional attribution. */
		}
	}, [path, target, reachGoal]);
	return null;
}
